var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member_box" },
    [
      _c("div", { staticClass: "search_criteria" }, [
        _c(
          "div",
          {
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onInquire($event)
              },
            },
          },
          [
            _c("el-input", {
              attrs: { placeholder: "输入清单名称搜索", clearable: "" },
              model: {
                value: _vm.queryData.shareTitle,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "shareTitle", $$v)
                },
                expression: "queryData.shareTitle",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onInquire($event)
              },
            },
          },
          [
            _c("el-input", {
              attrs: { placeholder: "输入用户手机号查询", clearable: "" },
              model: {
                value: _vm.queryData.phone,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "phone", $$v)
                },
                expression: "queryData.phone",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onInquire($event)
              },
            },
          },
          [
            _c("el-input", {
              attrs: { placeholder: "输入用户昵称查询", clearable: "" },
              model: {
                value: _vm.queryData.nickname,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "nickname", $$v)
                },
                expression: "queryData.nickname",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "是否共享", clearable: "" },
                model: {
                  value: _vm.queryData.isShared,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "isShared", $$v)
                  },
                  expression: "queryData.isShared",
                },
              },
              [
                _c("el-option", { key: 0, attrs: { value: 0, label: "否" } }),
                _vm._v(" "),
                _c("el-option", { key: 1, attrs: { value: 1, label: "是" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "选择状态", clearable: "" },
                model: {
                  value: _vm.queryData.upStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "upStatus", $$v)
                  },
                  expression: "queryData.upStatus",
                },
              },
              [
                _c("el-option", { key: 0, attrs: { value: 0, label: "下架" } }),
                _vm._v(" "),
                _c("el-option", { key: 1, attrs: { value: 1, label: "上架" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onInquire } },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c("el-button", { on: { click: _vm.onReset } }, [_vm._v("重置")]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "shareTitle",
                  label: "清单名称",
                  align: "center",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "清单头图",
                  align: "center",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.topPicUrl
                          ? _c("img", {
                              staticClass: "thumb-img",
                              attrs: { src: scope.row.topPicUrl },
                              on: {
                                click: function ($event) {
                                  return _vm.previewImage(scope.row.topPicUrl)
                                },
                              },
                            })
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "所属用户",
                  align: "center",
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "user-name pointer",
                            on: {
                              click: function ($event) {
                                return _vm.onUserDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.nickname || "-"))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "user-id" }, [
                          _vm._v("UID:" + _vm._s(scope.row.memberId)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "用户手机号",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsCount",
                  label: "商品总数",
                  align: "center",
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "viewCount",
                  label: "分享打开次数",
                  align: "center",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "是否共享",
                  align: "center",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-color": "#13ce66",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onToggleShared(scope.row, $event)
                            },
                          },
                          model: {
                            value: scope.row.isShared,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "isShared", $$v)
                            },
                            expression: "scope.row.isShared",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "上架状态",
                  align: "center",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: [
                              "status-tag",
                              scope.row.upStatus === 1 ? "up" : "down",
                            ],
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.upStatus === 1 ? "上架" : "下架"
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.hasOffReason
                ? _c("el-table-column", {
                    attrs: {
                      label: "下架原因",
                      align: "center",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.offReason || "-") +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2580455067
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  align: "center",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  "min-width": "140",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.onEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "warning", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.onPreview(scope.row)
                              },
                            },
                          },
                          [_vm._v("预览")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt20", staticStyle: { "text-align": "right" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.page,
                  "page-sizes": [20, 30, 40],
                  "page-size": _vm.size,
                  layout: "total, prev, pager, next, sizes, jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewImgVisible,
            width: "500px",
            "show-close": true,
            "custom-class": "image-preview-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewImgVisible = $event
            },
          },
        },
        [
          _vm.previewImgUrl
            ? _c("img", {
                staticClass: "preview-image",
                attrs: { src: _vm.previewImgUrl },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.statusDialogVisible,
            width: "500px",
            title: "清单管理",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.statusDialogVisible = $event
            },
            closed: _vm.onStatusDialogClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "statusForm",
              staticClass: "status-dialog-body",
              attrs: {
                rules: _vm.statusRules,
                model: _vm.statusForm,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "清单状态：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.statusForm.upStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.statusForm, "upStatus", $$v)
                        },
                        expression: "statusForm.upStatus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("上架")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("下架")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.statusForm.upStatus === 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "下架原因：", prop: "offReason" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          maxlength: "100",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.statusForm.offReason,
                          callback: function ($$v) {
                            _vm.$set(_vm.statusForm, "offReason", $$v)
                          },
                          expression: "statusForm.offReason",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.statusSubmitting },
                  on: { click: _vm.onStatusSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.sharedDialogVisible,
            width: "420px",
            title: "是否共享",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.sharedDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "shared-dialog-body" }, [
            _c("p", [
              _vm._v("共享清单后，当前清单可作为达人推荐清单供其他用户使用"),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "tip" }, [
              _vm._v("(清单所属用户会被屏蔽)，确认共享？"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.onSharedCancel } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.sharedSubmitting },
                  on: { click: _vm.onSharedConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            width: "420px",
            title: "清单预览",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.previewLoading,
                  expression: "previewLoading",
                },
              ],
              staticClass: "preview-wrap",
            },
            [
              _vm.previewDetail
                ? _c(
                    "div",
                    { staticClass: "preview-card" },
                    [
                      _c("div", { staticClass: "preview-header" }, [
                        _c("div", { staticClass: "preview-title" }, [
                          _vm._v(_vm._s(_vm.previewDetail.shareTitle || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.previewDetail.topPicUrl
                        ? _c("img", {
                            staticClass: "preview-top",
                            attrs: { src: _vm.previewDetail.topPicUrl },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "preview-text" }, [
                        _vm._v(_vm._s(_vm.previewDetail.introText || "")),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.previewDetail.goodsList || [],
                        function (g, idx) {
                          return _c(
                            "div",
                            { key: idx, staticClass: "preview-goods" },
                            [
                              g.picUrl
                                ? _c("img", {
                                    staticClass: "preview-goods-img",
                                    attrs: { src: g.picUrl },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "preview-goods-info" }, [
                                _c(
                                  "div",
                                  { staticClass: "preview-goods-title" },
                                  [_vm._v(_vm._s(g.title))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "preview-goods-shop" },
                                  [_vm._v(_vm._s(g.shopTitle))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "preview-goods-tags" },
                                  [
                                    _c("span", [_vm._v("10.12 到期")]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v("月售" + _vm._s(g.sales) + "件"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "preview-goods-price" },
                                  [
                                    _c("span", [
                                      _vm._v("到手价 "),
                                      _c("span", { staticClass: "price" }, [
                                        _vm._v("¥" + _vm._s(g.couponPrice)),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "origin" }, [
                                      _vm._v("¥" + _vm._s(g.originPrice)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "preview-goods-reason" },
                                  [
                                    _vm._v(
                                      "\n              推荐理由：" +
                                        _vm._s(
                                          g.recommendReason ||
                                            "真的很好，强烈推荐，赶紧跟家人们一起分享吧"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                      _vm._v(" "),
                      !(
                        _vm.previewDetail.goodsList &&
                        _vm.previewDetail.goodsList.length
                      )
                        ? _c("div", { staticClass: "preview-empty" }, [
                            _vm._v("\n          没有更多了\n        "),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }